import React, { useState, useEffect } from "react";
import { getWithdrawDetail } from "../../api";
import "./index.less";
import { formatTs, getParamsFromHash } from "../../../../utils/common";
import ContactService from "../../../../components/contact-service";
import Loading from "../../../../components/loading";
import { trackGdp } from "../../../../utils/gio-report";
const realizationDetail = () => {
  const [loading, setLoading] = useState(true);
  const [withdrawDetail, setWithdrawDetail] = useState({
    status: 0,
    amount: 0,
    finishedTime: "",
    businessWithdrawId: "",
    submitTime: "",
    content: "",
    cardLastFour: "",
    errorCode: "",
    msg: ""
  });

  useEffect(() => {
    document.title = "提现详情";
    trackGdp("P20144", "B001");
    console.log("businessWithdrawId", getParamsFromHash("businessWithdrawId"));
    const businessWithdrawId = getParamsFromHash("businessWithdrawId");
    if (businessWithdrawId) {
      getWithdrawDetail({ businessWithdrawId })
        .then(res => {
          if ([0, 200].includes(res.code)) {
            setWithdrawDetail(res.data);
          } else {
            setWithdrawDetail({
              ...withdrawDetail,
              errorCode: res.code,
              msg: res.msg
            });
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);
  const TitleEnum = {
    1: {
      color: "rgba(0, 0, 0, 0.4)",
      title: "提现中"
    },
    2: {
      color: "#5A960A",
      title: "提现受理成功"
    },
    3: {
      color: "#FF4D4F",
      title: "提现失败"
    }
  };

  const getScheduleList = () => {
    const titleList = {
      1: "待提现成功",
      2: "提现受理成功",
      3: "提现失败"
    };

    const contentList = {
      1: "",
      2: `提现卡尾号${withdrawDetail.cardLastFour}，提现受理成功，到账时间取决于收款银行`,
      3: `提现失败了，失败原因：${withdrawDetail.msg}`
    };
    
    return [
      {
        status: 2,
        title: "开始提现",
        time: withdrawDetail.submitTime,
        content: `等待${
          withdrawDetail.status === 1 ? "提现" : "到账"
        }，预计3个工作日`
      },
      {
        status: withdrawDetail.status,
        title: titleList[withdrawDetail.status],
        time: [2, 3].includes(withdrawDetail.status)
          ? withdrawDetail.finishedTime
          : null, // 提现成功和失败有时间
        content: contentList[withdrawDetail.status]
      }
    ];
  };

  return loading ? (
    <Loading />
  ) : (
    <div className="realization-detail-content">
      <div style={{ width: "100%" }}>
        <div className="content">
          <div
            className="title-statu"
            style={{ color: TitleEnum[withdrawDetail?.status].color }}
          >
            {TitleEnum[withdrawDetail?.status].title}
          </div>
          <div className="amount">¥{withdrawDetail.amount}</div>
        </div>
        <div className="info">
          <div className="info-item">
            <div className="left">流水号</div>
            <div className="right">{withdrawDetail.businessWithdrawId}</div>
          </div>
          <div className="info-item">
            <div className="left">提现进度</div>
            <div className="right"></div>
          </div>
        </div>
        <div className="schedule-content">
          <div className="schedule-line">
            {getScheduleList() &&
              getScheduleList().map((item, index) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center"
                    }}
                    key={index}
                  >
                    <div
                      className="schedule-line-point"
                      style={{ backgroundColor: TitleEnum[item?.status].color }}
                    />
                    {index !== getScheduleList().length - 1 && (
                      <div className="schedule-line-line"></div>
                    )}
                  </div>
                );
              })}
          </div>
          <div className="schedule-item">
            {getScheduleList() &&
              getScheduleList().map((item, index) => {
                return (
                  <div className="schedule-box" key={index}>
                    <div
                      className="schedule-title"
                      style={{ color: TitleEnum[item?.status].color }}
                    >
                      {item.title}
                    </div>
                    {item.time && (
                      <div className="schedule-time">{formatTs(item.time)}</div>
                    )}
                    {item.content && (
                      <div className="schedule-detail">{item.content}</div>
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
      <div
        className="tel"
        onClick={() => {
          trackGdp("P20144", "B002");
        }}
      >
        <ContactService text="如有疑问，请联系客服" />
      </div>
    </div>
  );
};
export default realizationDetail;
